module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/full-crud-example/example/example.component.scss
// module id = ./src/app/components/examples/full-crud-example/example/example.component.scss
// module chunks = main